<template>
  <div class="flex-row gap-3 align-center text-color-secondary">
    <slot name="icon" />

    <OwnType :text="message" color="secondary" variant="title-regular" />
  </div>
</template>

<script lang="ts" setup>
import { OwnType } from '@/ui/OwnType'

defineProps<{
  message: string
}>()
</script>
